import {AbstractMainPlugin} from "../../AbstractMainPlugin";
import {Item} from "../../../models/Item";
import {ObjectConfig} from "../../../models/ObjectConfig";



export class FigureZoomPlugin extends AbstractMainPlugin {

  private zoomInput = null;

  static getBeforeItemComponents() {
    return [];
  }

  constructor(item:Item) {
    super(item);
    this.initZoom();
  }

  private initZoom(){
    if (this.item.config.getObjectConfig().getToolType() == ObjectConfig.TYPE_FIXED_FIGURE){
      this.zoomInput = this.item.config.getInputByName('__figure_zoom');

      if (!this.zoomInput){
        this.item.config.createInputValue('__figure_zoom', {value: 1, prev_zoom: null});
        this.zoomInput = this.item.config.getInputByName('__figure_zoom');
      }
    }
  }


}
